import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer>
      <div>
        <div className="fb-name">FutureSoulmates™</div>

        <div className="fb-sub">
          D. Gulati & Associates / DGA, Inc.
          <br />
          1148 Fifth Avenue · New York, NY 10128
          <br />
          A HelixFoundry.ai platform
          <br />
          Attorney: David K. Bowles, Bowles &amp; Johnson PLLC
        </div>
      </div>

      <div className="fc">
        <h5>Platform</h5>

        <Link to="/thescience">The Science</Link>

        <Link to="/dnacompatibility">DNA Compatibility</Link>

        <Link to="/familyplanning">Family Planning</Link>

        <Link to="/enterpriseapi">Enterprise API</Link>
      </div>

      <div className="fc">
        <h5>Company</h5>

        <Link to="/investors">Investors (Series A)</Link>

        <Link to="/patents-ip">Patents &amp; IP</Link>

        <Link to="/privacy-policy">Privacy Policy</Link>

        <Link to="/genetic-counselling">
          Genetic Counselling
        </Link>

        <Link to="/contact">Contact</Link>
      </div>

      <div className="f-bot">
        <span>
          © 2026 DGA, Inc. / FutureSoulmates™ · All rights reserved
        </span>

        <span>
          Not a medical diagnostic service. Genetic counselling available.
        </span>
      </div>
    </footer>
  );
};

export default Footer;